import { makeStyles } from 'tss-react/mui';

// @ts-ignore - tss-react type inference issue with CSS literal types and custom palette
export default makeStyles()((theme) => ({
  root: {
    position: 'relative' as const,
    height: '90vh',
    minHeight: '400px',
    [theme.breakpoints.up('lg')]: {
      height: '85vh',
      minHeight: '800px',
    },
  },
  heroImage: {
    position: 'absolute' as const,
    height: '100%',
    width: '100%',
    objectFit: 'cover' as const,
    objectPosition: '50% 20%',
  },
  gradientContainer: {
    position: 'absolute' as const,
    bottom: 0,
    width: '100%',
    height: '50%',
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'center' as const,
    alignItems: 'flex-end' as const,
    paddingBottom: theme.spacing(4),
    background: `linear-gradient(0deg, ${theme.palette.getRgba(
      theme.palette.common.black,
      0.9,
    )} 11%, rgba(0,0,0,0) 100%)`,
  },
  postTitle: {
    color: theme.palette.common.white,
    margin: theme.spacing(0, 2),
    [theme.breakpoints.up('lg')]: {
      margin: 0,
    },
  },
  skeleton: {
    backgroundColor: theme.palette.custom.grey,
  },
}));
